// corporate-headers.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export const corporateHeadersInterceptor: HttpInterceptorFn = (req, next) => {

  const clonedReq = req.clone({
    setHeaders: {
      'Content-Type': 'application/json',
      'x-business-domain': environment.CORPORATE.BUSINESS_DOMAIN,
      'x-business-subdomain': environment.CORPORATE.BUSINESS_SUBDOMAIN,
      'x-business-capability': environment.CORPORATE.BUSINESS_CAPABILITY,
      'x-country': environment.CORPORATE.COUNTRY,
      'x-channel': environment.CORPORATE.CHANNEL,
      'x-app': environment.CORPORATE.APP
    }
  });

  return next(clonedReq);
};